import React from "react";
import "isomorphic-fetch";

class Contact extends React.Component {
  state = {
    submitting: false,
    submitted: false,
    submitError: "",
    buttonState: "",
    formFields: {
      name: "",
      email: "",
      phone: "",
      text: "",
    },
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (this.state.submitting) return;

    const data = {
      access_key: "ca62679f-4684-4fea-b22a-4ab66fd55f0f",
      name: this.state.formFields.name,
      email: this.state.formFields.email,
      phone: this.state.formFields.phone,
      message: this.state.formFields.text,
      subject: "New website inquiry",
      from_name: "Arch Website",
    };

    this.setState({ submitting: true, submitError: "" });

    fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          this.setState({ submitted: true });
          let formFields = Object.assign({}, this.state.formFields);
          formFields.name = "";
          formFields.email = "";
          formFields.phone = "";
          formFields.text = "";
          this.setState({ formFields });
        } else {
          this.setState({
            submitError:
              result.message || "Something went wrong. Please try again.",
          });
        }
      })
      .catch(() => {
        this.setState({
          submitError: "Network error. Please try again in a moment.",
        });
      })
      .finally(() => {
        this.setState({ submitting: false });
      });
  };

  nameChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.name = e.target.value;
    this.setState({ formFields });
  };

  emailChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.email = e.target.value;
    this.setState({ formFields });
  };

  phoneChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.phone = e.target.value;
    this.setState({ formFields });
  };

  textChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.text = e.target.value;
    this.setState({ formFields });
  };

  onHideSuccess = () => {
    this.setState({ submitted: false });
  };

  onHideError = () => {
    this.setState({ submitError: "" });
  };

  successMessage = () => {
    if (this.state.submitted) {
      return (
        <div
          className="alert alert-success alert-dismissible fade show"
          style={{ marginTop: "20px", marginBottom: "0" }}
        >
          <strong>Thank you!</strong> Your message has been sent.
          <button
            type="button"
            className="btn-close"
            onClick={this.onHideSuccess}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      );
    }
  };

  errorMessage = () => {
    if (this.state.submitError) {
      return (
        <div
          className="alert alert-danger alert-dismissible fade show"
          style={{ marginTop: "20px", marginBottom: "0" }}
        >
          <strong>Sorry!</strong> {this.state.submitError}
          <button
            type="button"
            className="btn-close"
            onClick={this.onHideError}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      );
    }
  };
  render() {
    return (
      <section id="contact" className="contact-area ptb-80 bg-f6f6f6">
        <div className="container">
          <div className="section-title">
            <h4>Get in Touch</h4>
            <h2>
              Let's <span>Contact</span> Us
            </h2>
            <p>
              Ready to take the next step towards transforming your digital
              presence? We'd love to hear from you! Reach out to us using the
              contact information below or fill out the form, and one of our
              representatives will get back to you as soon as possible.
            </p>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-12">
              <iframe
                title="Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2928.4849442928016!2d-71.25647192398813!3d42.77809697115708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e3abc66dc75687%3A0xcceec51b2709c124!2s5%20Industrial%20Way%2C%20Salem%2C%20NH%2003079%2C%20USA!5e0!3m2!1sen!2sin!4v1708006254586!5m2!1sen!2sin"
                width="100%"
                height="392"
                loading="lazy"
              ></iframe>

              <div className="contact-info">
                <ul>
                  <li>
                    <i className="fa fa-map-marker"></i> 5 Industrial Way, Salem
                    NH 3B, 03079
                  </li>
                  <li>
                    <i className="fa fa-envelope"></i>
                    <a href="mailto:help@archtechnologies.com">
                      help@archtechnologies.com
                    </a>
                  </li>
                  <li>
                    <i className="fa fa-phone"></i>
                    <a href="tel:855-603-2724">855-603-2724</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="contact-form">
                <h4>Stay Connected</h4>
                <form id="contactForm" onSubmit={this.onSubmit}>
                  <div className="row">
                    <div className="col-lg-12 col-md-6">
                      <div className="form-group">
                        <label htmlFor="name">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          id="name"
                          required={true}
                          data-error="Please enter your name"
                          value={this.state.formFields.name}
                          onChange={this.nameChangeHandler}
                        />
                      </div>
                    </div>

                    <div className="col-lg-12 col-md-6">
                      <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          id="email"
                          required={true}
                          data-error="Please enter your email"
                          value={this.state.formFields.email}
                          onChange={this.emailChangeHandler}
                        />
                      </div>
                    </div>

                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <label htmlFor="number">Phone Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="number"
                          id="number"
                          required={true}
                          data-error="Please enter your number"
                          value={this.state.formFields.phone}
                          onChange={this.phoneChangeHandler}
                        />
                      </div>
                    </div>

                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <label htmlFor="message">Message</label>
                        <textarea
                          name="message"
                          className="form-control"
                          id="message"
                          cols="30"
                          rows="4"
                          required={true}
                          data-error="Write your message"
                          value={this.state.formFields.text}
                          onChange={this.textChangeHandler}
                        />
                      </div>
                    </div>

                    <div className="col-lg-12 col-md-12">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={this.state.submitting}
                      >
                        {this.state.submitting ? "Sending..." : "Send Message"}
                      </button>
                      {this.successMessage()}
                      {this.errorMessage()}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Contact;
